<template>
  <div v-show="showBar" class="ds-control ds-button-bar" :class="getCss">
    <div class="bar-wrap">
      <template v-if="isDesign&&showButtonsReal.length==0">
        <div style="text-align:center;background-color:#fff;width:100%;padding:5px 0px;font-style:italic;color:#c0c0c0;">
          未配置按钮
        </div>
      </template>
      <template v-for="(button, $index) in showButtonsReal">
        <template v-if="hasChild(button)">
          <MenuButton :key="`children_button_popover_${$index}`" :button="button" :owner="_self"></MenuButton>
        </template>
        <!--上传按钮-->
        <template v-else-if="button.isUpload">
          <!-- 未上传模版 -->
          <UploadButton v-if="showUploadbutton(button)" :key="`upload_button_${$index}`" :button="button" :owner="_self"></UploadButton>
          <!-- 上传了模板则显示普通按钮打开弹窗 -->
          <DsfButton v-else :key="`upload_button_template_${$index}`" :icon="getIcon(button)" :title="button.title" :disabled="button.disabled" :size="size" :type="button.type" :btn-style="button.btnStyle" :icon-position="button.iconPosition" :style="button.style" :loading="button.loading" @click="clickHandler(button, $event)">
            {{ button.text }}
          </DsfButton>
        </template>
        <!--流程按钮-->
        <template v-else-if="button.isLinkSend && button.isLinkSendFold && (button.actionName === 'system_flow_send' || button.actionName === 'system_batch_flow_send')">
          <FlowButton :key="`morebutton_${$index}`" :button="button" :owner="_self"></FlowButton>
        </template>
        <!--普通按钮-->
        <template v-else>
          <DsfButton :key="`__${$index}`" :icon="getIcon(button)" :title="button.title" :disabled="button.disabled" :size="size" :type="button.type" :btn-style="button.btnStyle" :icon-position="button.iconPosition" :style="button.style" :loading="button.loading" @click="clickHandler(button, $event)">
            {{ button.text }}
          </DsfButton>
        </template>
      </template>
      <!--更多-->
      <MoreButton v-if="moreButtonsReal.length" ref="morebutton" @mousedown="moreButtonMouseDownHandler($event)" :owner="_self" :moreBtnColNum="moreBtnColNum"></MoreButton>
    </div>
  </div>
</template>
<script>
const UploadButton=Vue.defineLazyComponent(()=>require('./uploadButton'));
const FlowButton=Vue.defineLazyComponent(()=>require('./flowButton'));
const MenuButton=Vue.defineLazyComponent(()=>require('./menuButton'));
const MoreButton=Vue.defineLazyComponent(()=>require('./moreButton'));


export default dsf.component({
  name: "DsfButtonBar",
  ctrlCaption: "按纽组",
  mixins: [$mixins.control, $mixins.buttonBar],
  components: {
    UploadButton,
    FlowButton,
    MenuButton,
    MoreButton
  },
  props: {
    moreBtnColNum: {
      type: [Number, String],
      default: 5
    }
  },
  computed: {
    showBar() {
      if (this.isDesign) {
        return true;
      } else {
        return this.visible ? this.validButtons.length > 0 : false;
      }
    },
    getCss() {
      let css= [
        ...this.$getClass(),
        "align-" + this.align,
        this.textButtons?"ds-text-button-bar":'',
        this.iconButtons?"ds-icon-button-bar":''
      ];
      return css;
    },
    validButtons() {
      let buttons = _.filter(this.buttons, (button, index) => {
        if (this.showAndHide(button)) {
          this.disabledFactor(button);
          return true;
        }
        return false;
      });
      return buttons;
    },
    moreButtonsReal() {
      return _.filter(this.validButtons, (button, index) => {
        return index >= this.maxNumber;
      });
    },
    showButtonsReal() {
      return _.filter(this.validButtons, (button, index) => {
        return index < this.maxNumber;
      });
    },
    textButtons() {
      return _.some(this.showButtonsReal, (btn) => btn.textButton);
    },
    iconButtons() {
      return _.some(this.showButtonsReal, (btn) => btn.iconButton);
    }
  },
  data() {
    return {
      showButtons: [],
      moreButtons: [],
      moreFold: true,
      flowButtons: [],
      buttonHandler: dsf.buttons.getButtonHander,
      client: "pc",
      flowCurInfo: null,
      loading: null
    };
  },
  created() {},
  updated() {
    // console.log(this.buttons)
  },
  beforeDestroy() {},
  methods: {
    showUploadbutton(button) {
      let [index, index2] = button?.uploadSuccessHandlerParamIndex || [];
      if (!index || !index2) return true;
      if (
        !button.isUploadImportTemplate ||
        !button.params[index] ||
        !button.params[index].value.code
      )
        return true;
      return false;
    },
    hasChild(btn) {
      return btn?.children && Array.isArray(btn.children) && btn.children.length > 0;
    },
    moreButtonMouseDownHandler(evt) {
      //点击更多按钮时关闭当前页面上所有由更多按钮产生的浮动层
      let dsButtonBars = document.querySelectorAll(".ds-button-bar");
      _.each(dsButtonBars || [], (it) => {
        let morebutton = it?.__vue__?.$refs?.["more-button-popover"];
        if (this.$refs["more-button-popover"] !== morebutton) {
          it?.__vue__?.$refs?.["more-button-popover"]?.doClose?.();
        }
      });
    },
    reloadData() {
      this.$forceUpdate();
    },
    disabledFactor(button) {
      let result = false;
      if (!this.isDesign && !this.$isPreView) {
        //非设计模式下运行表达式
        if (button.disabledFactor) {
          let data = this.$expressParams(this.local);
          result = this.$eval(button.disabledFactor, data) !== false;
        } else {
          result = dsf.isDef(button.disabled) ? button.disabled : false;
        }
        if (this.disabledButton) {
          result = this.disabledButton(button, result, data);
        }
      }
      button.disabled = result;
    },
    showAndHide(button) {
      let result = true;
      if (!this.isDesign && !this.$isPreView) {
        let data = this.$expressParams(this.local);
        //非设计模式下运行表达式
        if (button.if) {
          result = this.$eval(button.if, data) !== false;
          if (!result) {
            if (dsf.debug == "1") {
              dsf.warn(`${button?.text}被表达式隐藏了`);
            }
          }
        } else {
          if (button.syncRead && (this?.owner?.readOnly || this?.$vm?.$data?.$forceReadOnly)) {
            result = false;
            if (dsf.debug == "1") {
              dsf.warn(`${button?.text}只读状态`);
            }
          } else {
            result = true;
          }
        }
        // 流程按钮需要判断
        if (result && button.isSystem && (button.actionName.indexOf("system_flow") > -1 || button.actionName.indexOf("system_batch_flow") > -1)) {
          if (this.$form) {
            result = this.hideFlowBtn(button);
          }
          if (!result) {
            if (dsf.debug == "1") {
              dsf.warn(`${button?.text}被流程隐藏了，检查sPID，STATUS`);
            }
          }
        }
        if (button.visible === false) {
          result = false;
          if (dsf.debug == "1") {
            dsf.warn(`${button?.text}，是否可见属性为否`);
          }
        }
        if (this.renderButton) {
          result = this.renderButton(button, result, data);
        }
      }
      return result;
    },
    getIcon(button) {
      let icon = button.icon;
      if (icon && icon.startsWith("icon-")) {
        return icon.replace("icon-", "");
      }
      return icon;
    },
    popoverShow() {
      this.moreFold = false;
      this.$emit("popoverState",this.moreFold)
    },
    popoverClose() {
      this.moreFold = true;
      this.$emit("popoverState",this.moreFold)

    },
    //触发指定按钮的点击事件
    triggerButtonClick(button) {
      this.clickHandler(button);
    },
    //上传类按钮处理 start
    uploadUrl(button) {
      let params = this.getButtonParams(button);
      let url = params[0];
      //this.$replace(button.params[0].value || button.params[0].default);
      return dsf.url.getWebPath(url);
    },
    getFileAccept(button) {
      if (this.isDesign) return "";
      let params = this.getButtonParams(button);
      let allowList = params[2]?.split("|");
      let map = _.map(allowList, (el) => {
        el = el.toLowerCase();
        return dsf.mime[el] || el;
      });
      return map.join(",");
    },
    beforeAvatarUpload(button) {
      return ((file) => {
        let params = this.getButtonParams(button);
        let allowList = params[2]?.split("|");
        let mark = false;
        for (let i = 0; i < allowList.length; i++) {
          let item = allowList[i].toLowerCase();
          if (item == "*" || file.name.toLowerCase().endsWith("." + item)) {
            mark = true;
            break;
          }
        }
        if (!mark) {
          dsf.layer.message("只能上传" + allowList.join(",") + "类型的文件", false);
          this.loading && dsf.layer.closeLoading(this.loading);
          return false;
        }
      }).bind(this);
    },
    handleProgress(e, file, fileList) {
      // 进度条
      let { loaded, total } = e;
      let persent = _.floor((loaded * 100) / total) || 0;
      this.loading.text = `文件上传中... (${persent}%)`;
    },
    handleChange(file, fileList) {
      if (file.status === "ready") {
        this.loading = dsf.layer.loading({
          text: "文件上传中... (0%)"
        });
      }
    },
    handleAvatarSuccess(button) {
      return ((res, file) => {
        dsf.layer.closeLoading(this.loading);
        this.clickHandler(button, undefined, res);
      }).bind(this);
    },
    async uploadClickBefore(button, $event) {
      if (this.isDesign) {
        return;
      }
      if (this.$isPreView) {
        dsf.layer.message("预览状态下按钮不可执行此操作", false);
        return;
      }
      if (!button.execing) {
        button.execing = true;
        let elUploadEl = $($event.target);
        if (!elUploadEl.hasClass("el-upload")) {
          elUploadEl = elUploadEl.parents(".el-upload").eq(0);
        }
        let inputEl = elUploadEl.find(".el-upload__input");
        try {
          await this.clickBeforeHandler(button, $event)
            .then(() => {
              setTimeout(() => {
                inputEl?.click();
                button.execing = false;
              });
            })
            .catch(() => {
              button.execing = false;
            });
        } catch (error) {
          dsf.error(error);
          button.execing = false;
        }
      }
    },
    getHeaders() {
      return dsf.getDefaultHttpHeader();
    },
    getUploadData(button) {
      let params = this.getButtonParams(button);
      let data = params[1];
      data = dsf.url.queryStringParse(data);
      return data;
    },
    hidePopVisible(button) {
      this.buttons.forEach((btn) => {
        if (btn.popVisible) {
          btn.popVisible = false;
        }
      });
      document.removeEventListener("click", this.hidePopVisible);
    }
  }
});
</script>
